module.exports = __webpack_public_path__ + "static/media/infinity.b6ac16bc.svg";